import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpEvent
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, timeout } from 'rxjs/operators';

import { Logger } from '@app/_helpers/logger';
import { Router } from '@angular/router';
import { ErrorMapperService } from './error-mapper.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorsInterceptor implements HttpInterceptor {

    constructor(
        private readonly logger: Logger,
        private readonly router: Router,
        private readonly errorMapper: ErrorMapperService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req)
            .pipe(
                timeout(5000),
                retry(2),
                catchError(this.handleError<any>(req.method, req.urlWithParams))
            );
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     *
     * @param method - method of the operation that failed
     * @param url - url of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(method: string, url: string): (error: unknown) => Observable<T> {
        return (error: any): Observable<T> => {
            const appError = this.errorMapper.toAppError(error);

            if (appError.type === 'authentication') {
                this.handleAuthenticationError();
            }

            this.logger.err(error, `${method} ${url} failed: ${appError.type}`);

            return throwError(() => appError);
        };
    }

    private handleAuthenticationError(): void {
        void this.router.navigate(['/login']);
    }
}
